export const daoCategoryItems = [
  {
    value: "Investment",
    label: "Investment",
  },
  {
    value: "Grant",
    label: "Grant",
  },
  {
    value: "Protocol",
    label: "Protocol",
  },
  {
    value: "Social",
    label: "Social",
  },
  {
    value: "Research",
    label: "Research",
  },
];

export const daoCategoryItems1 = [
  {
    value: "DAO",
    label: "DAO",
  },
  {
    value: "Social",
    label: "Social",
  },
  {
    value: "Investment",
    label: "Investment",
  },
  {
    value: "DeFi",
    label: "DeFi",
  },
  {
    value: "NFT",
    label: "NFT",
  },
  {
    value: "Metaverse",
    label: "Metaverse",
  },
  {
    value: "Gaming",
    label: "Gaming",
  },
  {
    value: "Launchpad",
    label: "Launchpad",
  },
  {
    value: "Stablecoin",
    label: "Stablecoin",
  },
  {
    value: "Meme",
    label: "Meme",
  },
  {
    value: "Oracles",
    label: "Oracles",
  },
  {
    value: "PlaytoEarn",
    label: "Play to Earn",
  },
  {
    value: "Interoperability",
    label: "Interoperability",
  },
  {
    value: "Scaling",
    label: "Scaling",
  },
  {
    value: "Entertainment",
    label: "Entertainment",
  },
  {
    value: "Exchange",
    label: "Exchange",
  },
  {
    value: "Web3",
    label: "Web3",
  },
  {
    value: "UniversalProfile",
    label: "Universal Profile",
  },
  {
    value: "LuksoEcosystem",
    label: "Lukso Ecosystem",
  },
  {
    value: "Lukso",
    label: "Lukso",
  },
  {
    value: "Derivatives",
    label: "Derivatives",
  },
  {
    value: "Governance",
    label: "Governance",
  },
  {
    value: "eCommerce",
    label: "e-commerce",
  },
  {
    value: "Education",
    label: "Education",
  },
  {
    value: "Analytics",
    label: "Analytics",
  },
];
